import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const Note: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
        <path d="M 49.777847,6.222229 V 34.222214 H 34.222168 V 49.77786 H 6.222242 V 6.222229 Z M 49.777847,0 H 6.222242 C 2.7999985,0 0,2.8000223 0,6.222229 V 49.77786 C 0,53.199948 2.7999985,56 6.222242,56 H 37.333244 L 56,37.333284 V 6.222229 C 56,2.8000223 53.199942,0 49.777847,0 Z M 28.000015,34.222214 H 12.444454 v -6.22214 H 28.000015 Z M 43.555694,21.777637 h -31.11124 v -6.22208 h 31.11124 z" />
    </SvgIcon>
  );
};

export default Note;
